import {sbxCoreService} from "../Network";


export const getCompanyPerCustomer = (userKey:string) => {
  const fetchData = ["user", "customer"];
  return sbxCoreService.with('company')
    .fetchModels(fetchData)
    .andWhereItContains('user',userKey)
    .andWhereIsEqualTo('active',true)
    .loadAll(fetchData);
};

export const getBranchPerCompany = (parentKey:string) => {
  const fetchData = ["parent"];
  return sbxCoreService.with('customer')
    .fetchModels(fetchData)
    .andWhereItContains('parent',parentKey)
    .loadAll(fetchData)
};
